export const ErrorCode ={
  SessionMissing : -100002,
  overTimeMissing: -100001
}


// WEBPACK FOOTER //
// ./src/util/errorcode.js